import fr from 'facet-rest';
import IncomeStepOverride from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/IncomeStep/MetaOverride';

export const IncomeSalaryPayStubUploadOverride = fr.metaOverride({ base: IncomeStepOverride });
